export enum TrangThaiHoatDongEnum {
  DANG_HOAT_DONG = 'Đang hoạt động',

  DANG_DAU_TU = 'Đang đầu tư',
}
